import { Link } from "react-router-dom";

export default function RefundPage() {
  return (
    <div className="min-h-screen bg-[#0a0a0f] text-white">
      <main className="mx-auto max-w-3xl px-4 py-10">
        <Link to="/" className="text-violet-400 hover:underline">← Back</Link>
        
        <h1 className="text-4xl font-bold mt-6 mb-4">Refund Policy</h1>
        <p className="text-white/50 mb-8"><strong>Effective Date:</strong> February 2, 2026</p>

        <div className="prose prose-invert max-w-none space-y-6 text-white/70">
          <h2 className="text-2xl font-semibold text-white">Subscriptions</h2>
          <p>Subscription fees are generally non-refundable except where required by law.</p>

          <h2 className="text-2xl font-semibold text-white mt-8">Credits / Charge-ups</h2>
          <p>Credits and add-ons are generally non-refundable because they unlock immediate usage.</p>

          <h2 className="text-2xl font-semibold text-white mt-8">Billing errors</h2>
          <p>
            If you believe you were billed in error, <Link to="/contact" className="text-violet-400 hover:underline">contact support</Link> promptly for review.
          </p>
        </div>
      </main>
    </div>
  );
}
